export default "__VITE_ASSET__BwS$bTYF__"